export const tristateEquivalence = {
  all: undefined,
  no: false,
  yes: true,
};
